import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { EntraUserToken } from './EntraUserTokenExtension';

export const entraUserTokenField = {
  name: 'EntraUserToken',
  component: EntraUserToken,
};

export const EntraUserTokenExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(entraUserTokenField),
);
